export class BaseDto {
	type!: string;
}
